export default __webpack_public_path__ + "static/media/verr_1.990847bc.png";